<template>
  <div class="download-main-layout">
    <section class="download-content">
      <div v-if="isNum == 1" class="download-list">
        <div
          class="download-card"
          v-for="(item, index) in loadList"
          :key="index"
          @click="goDetail(item)"
          style="cursor:pointer;"
        >
          <div class="download-cover">
            <img :src="getImg(item)" :alt="item.name" />
            <div class="download-action" @click.stop>
              <el-tooltip content="下载" placement="top">
                <el-button
                  icon="el-icon-bottom"
                  circle
                  size="small"
                  @click="dolow(item)"
                ></el-button>
              </el-tooltip>
            </div>
            <div class="download-meta-bottom">
              <span class="download-meta-item"
                ><i class="iconfont iconai-eye"></i>{{ item.pv }}</span
              >
              <span class="download-meta-item"
                ><i class="iconfont iconaixin"></i>{{ item.laud }}</span
              >
            </div>
          </div>
          <div class="download-info">
            <div class="download-title-row">
              <el-tooltip :content="item.name" placement="top">
                <span class="download-title">{{ item.name }}</span>
              </el-tooltip>
              <span
                class="download-type"
                :class="getModuleClass(item.module, item.type)"
                >{{ getModuleName(item.module, item.type) }}</span
              >
            </div>
            <div class="download-date-row">
              <span class="download-date">{{ item.time }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="download-empty" v-else>
        <img
          v-if="showEmptyImg"
          src="https://img.icons8.com/ios/452/nothing-found.png"
          alt="暂无下载"
          class="download-empty-img"
        />
        <div class="download-empty-title">还没有下载模板</div>
        <router-link :to="{ name: 'indexPage' }">
          <el-button type="primary">去首页看看</el-button>
        </router-link>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loadList: [],
      isNum: 0,
      showEmptyImg: false
    };
  },
  methods: {
    getImg(item) {
      let img = item.cover || item.image || "";
      if (img && img.indexOf(",") !== -1) {
        img = img.split(",")[0];
      }
      return img;
    },
    getModuleClass(module, type) {
      const classMap = {
        'chuangxin': 'type-chuangxin',
        'ppt': 'type-ppt',
        'word': 'type-word',
        'zygh': 'type-zygh',
        'datiao': 'type-datiao',
        'xiaotiao': 'type-xiaotiao'
      };
      return classMap[module] || 'type-default';
    },
    getModuleName(module, type) {
      const nameMap = {
        'chuangxin': '创新大赛',
        'ppt': '新文科PPT',
        'word': '新文科Word',
        'zygh': '职业规划',
        'datiao': '大挑',
        'xiaotiao': '小挑'
      };
      return nameMap[module] || '未知模块';
    },
    goDetail(item) {
      let link;
      switch (item.module) {
        case 'chuangxin':
          // 创新大赛模块 - 跳转到详情页
          link = this.$router.resolve({
            name: "Detailspage",
            query: { type: item.type, code: item.code }
          });
          break;
        case 'ppt':
        case 'word':
          // 新文科PPT/Word模块 - 跳转到新文科详情页
          link = this.$router.resolve({
            name: "XinWenKeDetail",
            query: { code: item.code }
          });
          break;
        case 'zygh':
          // 职业规划模块 - 跳转到详情页
          link = this.$router.resolve({
            name: "Detailspage",
            query: { type: item.type, code: item.code }
          });
          break;
        case 'datiao':
          // 大挑模块 - 跳转到大挑详情页
          link = this.$router.resolve({
            name: "BigChallengeDetail",
            query: { code: item.code }
          });
          break;
        case 'xiaotiao':
          // 小挑模块 - 跳转到小挑详情页
          link = this.$router.resolve({
            name: "SmallChallengeDetail",
            query: { code: item.code }
          });
          break;
        default:
          // 默认跳转到传统详情页
          link = this.$router.resolve({
            name: "Detailspage",
            query: { type: item.type, code: item.code }
          });
          break;
      }
      window.open(link.href, "_blank");
    },
    download() {
      this.axios
        .mydownload({
          params: {
            token: this.$store.state.token
          }
        })
        .then(res => {
          if (res.data.code == 200) {
            var arr = [];
            // 处理所有模块的数据
            if (res.data.data.chuangxin && res.data.data.chuangxin.rows) {
              arr = arr.concat(res.data.data.chuangxin.rows.map(item => ({ ...item, module: 'chuangxin' })));
            }
            if (res.data.data.ppt && res.data.data.ppt.rows) {
              arr = arr.concat(res.data.data.ppt.rows.map(item => ({ ...item, module: 'ppt' })));
            }
            if (res.data.data.word && res.data.data.word.rows) {
              arr = arr.concat(res.data.data.word.rows.map(item => ({ ...item, module: 'word' })));
            }
            if (res.data.data.zygh && res.data.data.zygh.rows) {
              arr = arr.concat(res.data.data.zygh.rows.map(item => ({ ...item, module: 'zygh' })));
            }
            if (res.data.data.datiao && res.data.data.datiao.rows) {
              arr = arr.concat(res.data.data.datiao.rows.map(item => ({ ...item, module: 'datiao' })));
            }
            if (res.data.data.xiaotiao && res.data.data.xiaotiao.rows) {
              arr = arr.concat(res.data.data.xiaotiao.rows.map(item => ({ ...item, module: 'xiaotiao' })));
            }

            // 处理图片字段
            arr.forEach(item => {
              if (!item.cover && item.image) item.cover = item.image;
            });

            // 按 code 去重
            const unique = {};
            const deduped = [];
            arr.forEach(item => {
              if (item.code && !unique[item.code]) {
                unique[item.code] = true;
                deduped.push(item);
              }
            });

            this.loadList = deduped;
            if (this.loadList.length != 0) {
              this.isNum = 1;
              this.showEmptyImg = false;
            } else {
              this.isNum = 2;
              // 延迟显示空图片，避免跳转时闪烁
              setTimeout(() => {
                this.showEmptyImg = true;
              }, 100);
            }
          } else {
            this.loadList = [];
            this.isNum = 2;
            setTimeout(() => {
              this.showEmptyImg = true;
            }, 100);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    dolow(val) {
      window.location.href = val.url;
    }
  },
  mounted() {
    this.download();
  }
};
</script>
<style scoped>
.download-main-layout {
  display: flex;
  height: 100vh;
  background: #f7f8fa;
}
.download-content {
  flex: 1;
  overflow-y: auto;
  padding: 36px 32px 32px 32px;
  min-width: 0;
}
.download-list {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 10px;
}
.download-card {
  background: #fafbfc;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  transition: box-shadow 0.2s, background 0.2s, border-color 0.2s;
  border: 1.5px solid #f3f3f3;
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.download-card:hover {
  background: #eaf6fd;
  box-shadow: 0 8px 32px rgba(88, 171, 224, 0.18);
  border-color: #58abe0;
  z-index: 2;
}
.download-cover {
  width: 100%;
  aspect-ratio: 16/10;
  background: #f0f2f5;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}
.download-cover img {
  width: 95%;
  height: 95%;
  object-fit: contain;
  border-radius: 5px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  transition: none;
  background: #fff;
}
.download-action {
  position: absolute;
  right: 16px;
  bottom: 12px;
  z-index: 2;
  opacity: 0;
  transition: opacity 0.2s;
  display: flex;
  align-items: center;
  gap: 6px;
}
.download-card:hover .download-action {
  opacity: 1;
}
.download-action .el-button {
  background: linear-gradient(90deg, #58abe0 0%, #7ed6fb 100%);
  color: #fff;
  font-weight: 700;
  border: none;
  box-shadow: 0 2px 8px rgba(88, 171, 224, 0.1);
  transition: background 0.2s, box-shadow 0.2s;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  min-width: 40px;
  min-height: 40px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.download-action .el-button:hover {
  background: linear-gradient(90deg, #47a1da 0%, #58abe0 100%);
  box-shadow: 0 4px 16px rgba(88, 171, 224, 0.18);
}
.download-action .download-btn-text {
  display: none;
}
.download-info {
  padding: 4px 10px 5px 15px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.download-title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 2px;
}
.download-title {
  font-size: 16px;
  font-weight: 500;
  color: #222;
  line-height: 1.2;
  margin-right: 8px;
  transition: color 0.2s;
  max-width: 160px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
  vertical-align: bottom;
}
.download-title:hover {
  color: #58abe0;
}
.download-type {
  font-size: 13px;
  font-weight: 600;
  padding: 2px 10px;
  border-radius: 10px;
  background: #eaf6fd;
  color: #58abe0;
  margin-left: 6px;
  margin-right: 0;
}
.type-word {
  background: #f8eafc;
  color: #b958e0;
}
.type-chuangxin {
  background: #fff2e8;
  color: #fa541c;
}
.type-zygh {
  background: #f6ffed;
  color: #52c41a;
}
.type-datiao {
  background: #fff1f0;
  color: #f5222d;
}
.type-xiaotiao {
  background: #f9f0ff;
  color: #722ed1;
}
.type-default {
  background: #f5f5f5;
  color: #666;
}
.download-meta-row {
  display: flex;
  align-items: center;
  gap: 18px;
  font-size: 14px;
  color: #888;
}
.download-date {
  color: #aaa;
  font-size: 13px;
  min-width: 90px;
  text-align: left;
}
.download-meta {
  display: flex;
  align-items: center;
  gap: 4px;
}
.download-meta-bottom {
  position: absolute;
  left: 16px;
  bottom: 14px;
  display: flex;
  align-items: center;
  gap: 18px;
  margin-top: 10px;
  z-index: 2;
}
.download-meta-item {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #888;
  background: rgba(255, 255, 255, 0.92);
  border-radius: 12px;
  padding: 2px 10px 2px 7px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
  font-weight: 500;
}
.download-meta-item i {
  font-size: 16px;
  margin-right: 4px;
  color: #58abe0;
}
.download-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 320px;
  width: 100%;
  background: #f8f8fa;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
  padding: 32px 0;
}
.download-empty-img {
  width: 150px;
  margin-bottom: 18px;
  opacity: 0.85;
}
.download-empty-title {
  font-size: 20px;
  font-weight: 600;
  color: #222;
  margin-bottom: 6px;
}
.download-date-row {
  margin-bottom: 8px;
  color: #aaa;
  font-size: 13px;
}
@media (max-width: 900px) {
  .download-main-layout {
    flex-direction: column;
  }
  .download-aside {
    width: 100%;
    min-width: 0;
    height: auto;
    box-shadow: none;
    border-bottom: 1px solid #f3f3f3;
  }
  .download-header-fixed {
    padding: 24px 0 12px 0;
    font-size: 22px;
  }
  .download-content {
    padding: 16px 2vw 16px 2vw;
    max-width: 98vw;
  }
  .download-list {
    grid-template-columns: 1fr;
    gap: 18px;
  }
}
</style>
